import { StrictMode } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { msalConfig } from "./auth/authConfig";
import { initializeTelemetry } from "./services/telemetry";
import "./styles/global.css";
import "./styles/glass-ui.css";
import "./styles/portal-navigation.css";

const msalInstance = new PublicClientApplication(msalConfig);

function applyDarkTheme() {
  document.documentElement.dataset.theme = "dark";
  window.localStorage.removeItem("dataops-theme");
}

async function renderApp() {
  applyDarkTheme();
  initializeTelemetry();
  await msalInstance.initialize();
  const redirectResult = await msalInstance.handleRedirectPromise().catch((error: unknown) => {
    console.error("Microsoft Entra redirect processing failed.", error);
    return null;
  });
  const activeAccount = redirectResult?.account || msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (activeAccount) {
    msalInstance.setActiveAccount(activeAccount);
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </StrictMode>
  );
}

void renderApp();
